import React from 'react';
import { useTranslation } from 'react-i18next';

function SettingsPage() {
    const { t } = useTranslation();
    
    return (
        <div className="page">
			<h1 className="text-black text-2xl pb-[90px]">{t('settings.title')}</h1>
        </div>
    );
};

export default SettingsPage;